import React from 'react';
import { Modal } from 'antd';
import { logout } from 'helpers/request';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { source } from 'apis';
import { safeLocationHref } from '../helpers/pathValidator';

export const errorBind = (status) => {
  const logoutClose = async () => {
    await logout('error');
  };

  const data = {
    '-901': {
      redirect: '/service/quick/landing'
      // open: false,
      // routeTo: '', 아직 지원 안됨
    },
    '-900': {
      // 에러 식권대장 서비스를 이용중이지 않음.
      redirect: '/service/landing?apply=true',
      stopBubble: true // 기존 화면에서 처리 하는걸 막는다.
    },
    '-800': {
      // 에러 퀵대장 서비스를 이용중이지 않음.
      redirect: '/service/landing',
      stopBubble: true // 기존 화면에서 처리 하는걸 막는다.
    },
    '500': {
      //   redirect: '/service/quick/landing'
      // open: false,
      // routeTo: '', 아직 지원 안됨
    },
    '-1002': {
      redirect: '/service/landing',
      open: true
    },
    '-1001': {
      // 사용자 인데 식권대장 권한 없음.
      redirect: '/service/landing',
      open: true,
      stopBubble: true // 기존 화면에서 처리 하는걸 막는다.
    },
    '-2303': {
      // token expired
      title: '강제 로그아웃',
      redirect: '/',
      stopBubble: true,
      close: logoutClose
    },
    '-2302': {
      // token expired
      title: '강제 로그아웃',
      redirect: '/',
      stopBubble: true,
      close: logoutClose
    },
    '-2307': {
      // multiple login
      title: '강제 로그아웃',
      redirect: '/',
      stopBubble: true, // 기존 화면에서 처리 하는걸 막는다.
      close: logoutClose
    },
    '-700': {
      // 일시 정지, 탈퇴 사용자
      title: '강제 로그아웃',
      redirect: '/',
      stopBubble: true,
      close: logoutClose
    },
    '-9300': {
      title: '강제 로그아웃',
      redirect: '/',
      stopBubble: true,
      close: logoutClose
    },
    '-1000': {
      nothing: true
    }
  };
  return data[status];
};

let isDuplPending = true;

const handler = (error) => {
  const { response, config } = error;

  // 호출부가 실패를 직접 표시하는 요청은 공통 안내 모달을 띄우지 않는다.
  // (예: 엑셀 일괄 저장처럼 건별 결과를 표에 채우는 경우 — 실패마다 모달이 뜨면 안 된다)
  if (config && config.skipErrorModal) return;

  if (response.status === 500 || response.status === 401) {
    const { status, message: content, title } = response.data;

    if (errorBind(status)) {
      const { redirect, routeTo, open = true, close, nothing } = errorBind(status);
      if (nothing) return;

      source.cancel('canceled');
      if (open) {
        Modal.confirm({
          title,
          content,
          icon: <ExclamationCircleOutlined />,
          okText: '확인',
          cancelButtonProps: { style: { display: 'none' } },
          onOk: async () => {
            if (close) await close();
            route({ redirect, routeTo });
          }
        });
      } else {
        // if(close) close();
        // route({redirect, routeTo})
        Modal.confirm({
          title,
          content,
          icon: <ExclamationCircleOutlined />,
          okText: '확인',
          cancelButtonProps: { style: { display: 'none' } },
          onOk: () => {}
        });
      }
    } else {
      Modal.confirm({
        title,
        content,
        icon: <ExclamationCircleOutlined />,
        okText: '확인',
        cancelButtonProps: { style: { display: 'none' } },
        onOk: () => {}
      });
    }
  }
};

const route = ({ redirect, routeTo }) => {
  if (redirect) {
    safeLocationHref(redirect);
  } else if (routeTo) {
  }
};
export default handler;
